module.exports = __webpack_public_path__ + "img/big-pic3.9d8d16ee.png";